import { render } from "./IconGithub.vue?vue&type=template&id=58627b94&scoped=true"
import script from "./IconGithub.vue?vue&type=script&lang=js"
export * from "./IconGithub.vue?vue&type=script&lang=js"

import "./IconGithub.vue?vue&type=style&index=0&id=58627b94&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58627b94"]])

export default __exports__